import { VARIANT_C_PLANS } from './SubscriptionPlans';

interface Upsell111AddonOptions {
  chargebeeId: string
  fullPrice: number
  discPrice: number
  roundedDiscPrice: number
  periodKey: string
}

function createUpsell111Addon({
  chargebeeId,
  fullPrice,
  discPrice,
  roundedDiscPrice,
  periodKey,
}: Upsell111AddonOptions): AddonPaymentModel {
  const payment: PaymentModel = {
    chargebeeId,
    discPrice,
    roundedDiscPrice,
  };

  return {
    id: 1,
    fullPrice,
    periodKey,
    planNameUpper: '',
    currencyCode: 'USD',
    currencySymbol: '$',
    standard: payment,
    super: { ...payment },
  };
}

export const UPSELL_111_PRICING_4WEEK = {
  fullPrice: 19.99,
  discPrice: 9.99,
  roundedDiscPrice: 999,
  periodKey: 'subscription_period_4week',
} as const;

export const UPSELL_111_PRICING_12WEEK = {
  fullPrice: 39.99,
  discPrice: 19.99,
  roundedDiscPrice: 1999,
  periodKey: 'subscription_period_12week',
} as const;

const UPSELL_111_ADDONS_4WEEK: SubscriptionUpsells = {
  groinFitness: createUpsell111Addon({
    ...UPSELL_111_PRICING_4WEEK,
    chargebeeId: 'Fitness-t1-USD-Every-4-weeks',
  }),
  sexologyCourses: createUpsell111Addon({
    ...UPSELL_111_PRICING_4WEEK,
    chargebeeId: 'Sexology-t1-USD-Every-4-weeks',
  }),
  guidedMeditations: createUpsell111Addon({
    ...UPSELL_111_PRICING_4WEEK,
    chargebeeId: 'Meditations-t1-USD-Every-4-weeks',
  }),
};

const UPSELL_111_ADDONS_12WEEK: SubscriptionUpsells = {
  groinFitness: createUpsell111Addon({
    ...UPSELL_111_PRICING_12WEEK,
    chargebeeId: 'Fitness-t1-USD-Every-12-weeks',
  }),
  sexologyCourses: createUpsell111Addon({
    ...UPSELL_111_PRICING_12WEEK,
    chargebeeId: 'Sexology-t1-USD-Every-12-weeks',
  }),
  guidedMeditations: createUpsell111Addon({
    ...UPSELL_111_PRICING_12WEEK,
    chargebeeId: 'Meditations-t1-USD-Every-12-weeks',
  }),
};

function resolveUpsell111Addons(planId: number): SubscriptionUpsells | undefined {
  if (planId === 1 || planId === 2) return UPSELL_111_ADDONS_4WEEK;
  if (planId === 3) return UPSELL_111_ADDONS_12WEEK;

  return undefined;
}

function assignPlanId(addons: SubscriptionUpsells, planId: number): SubscriptionUpsells {
  const entries = Object.entries(addons) as [keyof SubscriptionUpsells, AddonPaymentModel][];

  return Object.fromEntries(
    entries.map(([key, addon]) => [key, { ...addon, id: planId }]),
  ) as SubscriptionUpsells;
}

export const UPSELL_111_PLANS: SubscriptionModel[] = VARIANT_C_PLANS.map((plan) => {
  const addons = resolveUpsell111Addons(plan.id);

  return {
    ...plan,
    subscriptionUpsells: addons ? assignPlanId(addons, plan.id) : undefined,
  };
});
